export default __webpack_public_path__ + "static/media/Lustra-investor_rocket_DAO.265840be.svg";